import contactDisplayNames from "../displayNames";
import {
  FormFields,
  FormSection,
  PhoneInput,
  TextInput,
  DropDownLookUpInput,
  RadioInput,
  EmailInput,
  OptionSetInput,
} from "../../../types";
import {
  vdl_accessPortailChoices,
  vdl_fonctionChoices,
  vdl_salutationsChoices,
} from "./optionSetChoices";
import { contactOptionSetsChoices } from "../optionSetChoices";

export type NewContactFields = {
  vdl_salutation: OptionSetInput;
  firstname: TextInput;
  lastname: TextInput;
  vdl_fonction: OptionSetInput;
  emailaddress1: EmailInput;
  telephone1: PhoneInput;
  telephone2: PhoneInput;
  vdl_accesauportail: RadioInput;
  vdl_roledesecurite: DropDownLookUpInput;
};

const sectionInfos: FormSection<NewContactFields> = {
  fields: [
    "vdl_salutation",
    "firstname",
    "lastname",
    "emailaddress1",
    "vdl_fonction",
    "telephone1",
    "telephone2",
  ],
  title: "Informations personnelles",
};

const sectionSignUp: FormSection<NewContactFields> = {
  fields: [
    "vdl_salutation",
    "firstname",
    "lastname",
    "emailaddress1",
    "vdl_fonction",
    "telephone1",
    "telephone2",
  ],
};

const sectionAccess: FormSection<NewContactFields> = {
  fields: ["vdl_accesauportail", "vdl_roledesecurite"],
  title: "Accès au portail",
};

const newContactSections: FormSection<NewContactFields>[] = [
  sectionInfos,
  sectionAccess,
];

const newContactFields: NewContactFields = {
  vdl_salutation: {
    type: "options",
    error: "",
    value: null,
    choices: contactOptionSetsChoices.vdl_salutation,
    required: false,
    fillLine: true,
    label: contactDisplayNames.vdl_salutation,
  },
  firstname: {
    type: "text",
    value: "",
    error: "",
    required: true,
    label: contactDisplayNames.firstname,
  },
  lastname: {
    type: "text",
    value: "",
    error: "",
    required: true,
    label: contactDisplayNames.lastname,
  },
  vdl_fonction: {
    type: "options",
    choices: contactOptionSetsChoices.vdl_fonction,
    value: null,
    error: "",
    required: true,
    label: contactDisplayNames.vdl_fonction,
  },
  emailaddress1: {
    type: "email",
    value: "",
    error: "",
    required: true,
    label: contactDisplayNames.emailaddress1,
  },
  telephone1: {
    type: "phone",
    value: "",
    error: "",
    required: true,
    label: contactDisplayNames.telephone1,
  },
  telephone2: {
    type: "phone",
    value: "",
    error: "",
    required: false,
    label: contactDisplayNames.telephone2,
  },
  vdl_accesauportail: {
    type: "radio",
    error: "",
    value: "",
    choices: vdl_accessPortailChoices,
    required: false,
    fillLine: true,
    label: contactDisplayNames.vdl_accesauportail,
    onChangeEvent: (fields) =>
      onAccessauportailChange(fields as NewContactFields),
  },
  vdl_roledesecurite: {
    type: "lookup",
    value: "",
    error: "",
    choices: [],
    label: contactDisplayNames._vdl_roledesecurite_value,
    requiredCondition : {
      validator: (fields : FormFields) => fields.vdl_accesauportail.value === "Oui",
      error: "Vous devez donner un rôle à au contact s'il a accès au portail"
    },
    disabledCondition: (fields : FormFields) => fields.vdl_accesauportail.value !== "Oui",
  },
};

function onAccessauportailChange(
  fields: NewContactFields
): Partial<NewContactFields> | undefined {
  try {
    if (fields.vdl_accesauportail.value === "Oui") return undefined;

    return {
      vdl_roledesecurite: {
        ...fields.vdl_roledesecurite,
        value: null,
      },
    };
  } catch (e) {
    return undefined;
  }
}

const newContactForm = {
  fields: newContactFields,
  sections: newContactSections,
};

export {
  newContactForm,
  newContactFields,
  newContactSections,
  sectionInfos,
  sectionSignUp,
};
